import type { PublicApiKey } from '@/apilib';
import type { createClipboardApi } from './clipboardWrapper';

export const ClipboardApiKey: PublicApiKey<typeof createClipboardApi> = {
  name: 'ClipboardApi',
  public: true,
};
